import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";

function Promo() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [payment, setPayment] = useState(null); // Lưu lịch sử
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    // Cấu hình Interceptor
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    function formatDate(m) {
        const d = new Date(m);
        return d.getFullYear() + "/" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "/" + 
               ("0" + d.getDate()).slice(-2) + "  " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    const handleBackClick = () => {
        navigate(-1);
    };

    // Hàm lấy dữ liệu dùng chung
    const fetchData = () => {
        // Lấy thông tin User
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));
            })
            .catch(() => localStorage.removeItem("user"));

        // Lấy lịch sử khuyến mãi
        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`)
            .then((res) => setPayment(res.data.data))
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        fetchData();
    }, []);

    const onSubmit = (data) => {
        if (!data.code) {
            return swal("Thông báo", "Vui lòng nhập mã khuyến mãi", "warning");
        }
        
        axios.post(`${process.env.REACT_APP_API_URL}/promo/active`, { code: data.code })
            .then((res) => {
                swal("Thành Công", `Nhận thành công ${res.data.data.money.toLocaleString("vi-VN")}₫.`, "success");
                reset(); // Xóa text trong ô input
                fetchData(); // Load lại tiền và lịch sử ngay lập tức
            })
            .catch((err) => {
                const msg = err.response?.data?.message || "Đã xảy ra lỗi";
                swal("Thất bại", msg, "error");
            });
    };

    return (
        <>
            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">Nhập mã khuyến mãi</h1>
            </div>
            <div className="main">
                <div className="content_profile">
                    <AnimatedPage>
                        {/* Form nhập mã */}
                        <form className="form-lg form-box form-code" onSubmit={handleSubmit(onSubmit)} style={{ marginTop: "20px" }}>
                            <div className="inputs">
                                <div className="input">
                                    <label>Nhập mã khuyến mãi</label>
                                    <input
                                        className="ipadd"
                                        type="text"
                                        placeholder="Nhập mã khuyến mãi"
                                        {...register("code", { required: true })}
                                    />
                                </div>
                                <button type="submit" className="btn-submit">Xác nhận</button>
                            </div>
                        </form>

                        {/* PHẦN LỊCH SỬ THÊM VÀO DƯỚI ĐÂY */}
                        <div className="content-history" style={{ marginTop: "30px" }}>
                            <h3 style={{ color: "#fff", marginBottom: "15px", fontSize: "16px" }}>Lịch sử nhận thưởng</h3>
                            {payment ? (
                                payment.filter(item => ["KHUYẾN MÃI", "THƯỞNG", "ƯU ĐÃI"].includes(item.type_payment))
                                    .map((item, key) => (
                                        <div className="item_inner" key={key} style={{ marginBottom: "10px" }}>
                                            <div className="item_history">
                                                <div className="title_item_history">
                                                    <span className="sanh">{item.type_payment}</span>
                                                    <span className={`type_state ${item.status_payment === "Pending" ? "pending" : item.status_payment === "Success" ? "win" : "lose"}`}>
                                                        {item.status_payment === "Success" ? "Thành công" : item.status_payment === "Pending" ? "Chờ" : "Thất bại"}
                                                    </span>
                                                </div>
                                                {item?.detail && <div className="id_history_sanh" style={{ fontSize: "12px" }}>Nội dung: {item.detail}</div>}
                                            </div>
                                            <div className="money_history">
                                                <span className="money" style={{ color: "#ffc107" }}>
                                                    +{Number(item.money || item.km || 0).toLocaleString("vi-VN")}₫
                                                </span>
                                                <div className="time_choose" style={{ fontSize: "10px" }}>{formatDate(item.createdAt)}</div>
                                            </div>
                                        </div>
                                    ))
                            ) : (
                                <div className="no_record">Đang tải dữ liệu...</div>
                            )}
                            {payment && payment.filter(item => ["KHUYẾN MÃI", "THƯỞNG", "ƯU ĐÃI"].includes(item.type_payment)).length === 0 && (
                                <div className="no_record">Chưa có lịch sử nhận thưởng</div>
                            )}
                        </div>
                    </AnimatedPage>
                </div>
                <Footer profile={profile} />
            </div>
        </>
    );
}

export default Promo;